

























































































































































































































































































































































import { createComponent, inject, ref, reactive } from '@vue/composition-api'

import { useAppState } from '../lib/appState'
import { useAlertState } from '../lib/useAlert'

import { MainMapControllerSymbol } from '../symbols'
import { MapFactoryController } from '../lib/map'
import { createFactory } from '../api'
import { useImageUpload } from '../lib/imageUpload'

import ImageUploadForm from './ImageUploadForm.vue'
import ConfirmFactory from './ConfirmFactory.vue'
import SwitchMapModeButton from './SwitchMapModeButton.vue'
import { FactoryPostData } from '../types'
import { useGA } from '../lib/useGA'
import { useBackPressed } from '../lib/useBackPressed'
import { useModalState } from '../lib/hooks'
import DetailForm from './DetailForm.vue'

export default createComponent({
  name: 'CreateFactorySteps',
  components: {
    ImageUploadForm,
    ConfirmFactory,
    SwitchMapModeButton,
    DetailForm
  },
  setup () {
    const [appState, { pageTransition, setFactoryLocation }] = useAppState()
    const [, { openCreateFactorySuccessModal }] = useModalState()
    const [, alertActions] = useAlertState()
    const { event } = useGA()

    const discardDialog = ref(false)

    const mapController = inject(
      MainMapControllerSymbol,
      ref<MapFactoryController>()
    )

    function cancelCreateFactory () {
      if (mapController.value) {
        mapController.value.mapInstance.setLUILayerVisible(false)
        discardDialog.value = false
        // TODO: clear form value
        pageTransition.closeFactoryPage()
      }
    }

    const onBack = () => {
      if (appState.createStepIndex === 1) {
        cancelCreateFactory()
      } else if (appState.createStepIndex === 2) {
        if (mapController.value) {
          pageTransition.previousCreateStep()
        }
      } else {
        pageTransition.previousCreateStep()
      }
    }
    useBackPressed(onBack)

    const createFactoryFormState = reactive({
      submitting: false,
      nickname: '',
      contact: '',
      others: '',
      name: '',

      // 表單基礎資訊
      type: undefined, // 通報類型
      alreadyOhshown: undefined,
      alreadyOhshownNumber: undefined,
      /** locale date */
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      /** locale time */
      time: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(11, 16),

      // 環境地貌
      groundTypes: [], // 土地類型
      vegetations: [], // 植被
      bearAttractors: [], // 附近可能吸引熊接近的物品

      // 個體資訊
      bearNumber: undefined, // 目擊個體數
      bearType: [], // 個體種類（成熊、幼熊）
      bearSize: [], // 體型
      bearSex: [], // 性別
      bearFeature: [], // 其他特徵

      // 黑熊行為與反應
      ohshownFeeling: '', // 看到熊當下，目擊者的感覺
      humanNumber: undefined, // 目擊熊當下人數
      humanBehavior: undefined, // 目擊者目擊當下在做什麼
      humanBehaviorText: '', // 目擊者目擊當下在做什麼-文字補充
      distance: undefined, // 目擊當下，目擊者與熊之間的距離
      bearBehavior: undefined, // 目擊當下，熊在做什麼
      bearBehaviorText: '', // 目擊當下，熊在做什麼-文字補充
      food: [], // 黑熊食物
      foodText: {}, // 黑熊食物-文字補充
      bearNotice: undefined, // 黑熊何時注意到人員存在
      bearNoticeMinutes: undefined, // 目擊後約X分鐘黑熊發現人員存在-數字補充
      humanReaction: [], // 目擊黑熊後，目擊者反應
      humanReactionText: '', // 目擊者反應-文字補充
      bearReaction: [], // 黑熊發現目擊者後，黑熊的反應
      bearReactionText: '', // 黑熊反應-文字補充
      humanHurt: undefined, // 是否有人受傷或意外發生
      humanHurtDescription: '', // 是否有人受傷或意外發生-文字補充

      // 發現黑熊痕跡
      traceType: undefined, // 痕跡類型
      traceTypeText: '', // 痕跡類型-文字補充
      freshness: undefined, // 新舊估計
      freshnessNumber: undefined, // 新舊估計-數字補充
      imageAvailable: undefined, // 是否提供影像檔案
      otherInfo: '', // 其他補充說明

      // 下一次，如果有機會的話
      ohShownAgain: undefined, // 目擊者是否希望以後再看到野外的黑熊
      ohShownAgainReason: '', // 目擊者是否希望以後再看到野外的黑熊-原因
      preventOhshownMethods: [], // 您知道以下哪些做法有助於減少遇到熊的機會，或避免不愉快地與熊相遇
      preventOhshownMethodsText: '', // 您知道以下哪些做法有助於減少遇到熊的機會，或避免不愉快地與熊相遇-文字補充
      surveyIfBearExist: undefined // 您是否會先了解您預計前往的地點有無黑熊出沒
    })

    const {
      selectedImages,
      imageUploadState,
      uploadedImages,
      onClickRemoveImage,
      imageUploadFormValid
    } = useImageUpload()

    const submitFactory = async () => {
      createFactoryFormState.submitting = true

      try {
        const [lng, lat]: number[] = appState.factoryLocation
        const bears = [...Array(createFactoryFormState.bearNumber || 0).keys()].map(index => ({
          bearType: createFactoryFormState.bearType[index],
          bearSize: createFactoryFormState.bearSize[index],
          bearSex: createFactoryFormState.bearSex[index],
          bearFeature: createFactoryFormState.bearFeature[index]
        }))
        const factory: FactoryPostData = {
          ...createFactoryFormState,
          bears,
          lng,
          lat,
          images: uploadedImages.value.map((i) => i.token),
          /** 遭遇時間戳記 */
          datetime: Date.parse(`${createFactoryFormState.date}T${createFactoryFormState.time}`)
        }

        event('createFactory', { lng, lat })
        const resultFactory = await createFactory(factory)
        if (mapController.value) {
          mapController.value.addFactories([resultFactory])
        }
        pageTransition.closeFactoryPage()
        openCreateFactorySuccessModal()
      } catch (e) {
        alertActions.showAlert('伺服器錯誤，請稍後再試')
      } finally {
        createFactoryFormState.submitting = false
      }
    }

    const showLongLat = ref(false)
    const toggleShowLongLat = () => {
      showLongLat.value = !showLongLat.value
    }

    const chooseLocationDialog = ref(false)
    const inlineLocationForm = ref(false)
    const toggleInlineLocationForm = () => {
      inlineLocationForm.value = !inlineLocationForm.value
    }
    const locationInputState = reactive({
      longitude: '',
      latitude: ''
    })
    const clearLocationInput = () => {
      locationInputState.longitude = ''
      locationInputState.latitude = ''
    }
    const setLocation = () => {
      if (!mapController.value) return

      const lng = parseFloat(locationInputState.longitude)
      const lat = parseFloat(locationInputState.latitude)
      if (
        !locationInputState.longitude ||
        !locationInputState.latitude ||
        isNaN(lng) ||
        isNaN(lat)
      ) {
        // TODO: show invalid input error
        chooseLocationDialog.value = false
      } else {
        let zoom = mapController.value.mapInstance.map.getView().getZoom()
        if (!zoom || zoom <= 17) {
          zoom = 17
        }
        mapController.value.mapInstance.setCoordinate(lng, lat, zoom)
        chooseLocationDialog.value = false
      }
    }

    const switchStep = (num: number) => {
      const backSteps = appState.createStepIndex - num

      for (let i = 0; i < backSteps; i++) {
        onBack()
      }
    }

    return {
      appState,
      pageTransition,
      formState: createFactoryFormState,

      cancelCreateFactory,
      onBack,
      chooseLocation () {
        if (!mapController.value) return

        if (!appState.canPlaceFactory) {
          alertActions.showAlert(
            '此地點不在農地範圍內，\n請回報在農地範圍內的黑熊出沒痕跡。'
          )
          return
        }

        mapController.value.mapInstance.setLUILayerVisible(false)

        setFactoryLocation(appState.mapLngLat as [number, number])

        pageTransition.nextCreateStep()
      },
      selectedImages,
      imageUploadState,
      uploadedImages,
      onClickRemoveImage,
      imageUploadFormValid,
      discardDialog,
      submitFactory,
      showLongLat,
      toggleShowLongLat,
      chooseLocationDialog,
      inlineLocationForm,
      locationInputState,
      clearLocationInput,
      toggleInlineLocationForm,
      setLocation,
      switchStep
    }
  }
})
